export default __webpack_public_path__ + "static/media/031-tea cup.c40e8b24.svg";